module.exports = "/_next/static/images/309ec2b0fa83fbe5a87fed6ea6358816-two-people-looking-xs@1x.jpg";